
<template>
  <div class="card">
    <div style="width: 100%;overflow-x: scroll;">
      <table class="table">
        <thead>
          <tr>
            <th>ID</th>
            <th>Instrumento</th>
            <th>Punto</th>
            <th>Código</th>
            <th>Indicador</th>
            <th>Fecha Inicio</th>
            <th>Fecha Fin</th>
            <th>Responsable</th>
            <th>Periodicidad</th>
            <th>Estado FT</th>
            <th>Año Reporte</th>
            <th>Mes Reporte</th>
            <th>Periodo Reporte</th>
            <th>Tipo</th>
            <th>Meta</th>
            <th>Avance Reportado</th>
            <th>Fecha Recepción</th>
            <th>Fecha Revisión</th>
            <th>Observaciones</th>
            <th>Estado</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="indicador in valIndicadores" :key="indicador.id">
            <td>{{ indicador.id }}</td>
            <td>{{ indicador.instrumento }}</td>
            <td>{{ indicador.punto }}</td>
            <td>{{ indicador.codigo }}</td>
            <td>{{ indicador.indicador }}</td>
            <td>{{ indicador.fechaInicio.substring(0, 10) }}</td>
            <td>{{ indicador.fechaFin.substring(0, 10) }}</td>
            <td>{{ indicador.responsable }}</td>
            <td>{{ indicador.periodicidad }}</td>
            <td>{{ indicador.estadoFT }}</td>
            <td>{{ indicador.anioReporte }}</td>
            <td>{{ indicador.mesReporte }}</td>
            <td>{{ indicador.periodoReporte }}</td>
            <td>{{ indicador.tipo }}</td>
            <td>{{ indicador.meta }}</td>
            <td>{{ indicador.avanceReportado }}</td>
            <td>{{ indicador.fechaRecepcion.substring(0, 10) }}</td>
            <td>{{ indicador.fechaRevision.substring(0, 10) }}</td>
            <td>{{ indicador.observaciones }}</td>
            <td>{{ indicador.estado }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div id="pagination" class="pagination"></div>
  </div>
</template>



<script>
import { mapActions, mapGetters } from "vuex";

export default {
  name: "ReporteAvances",
  data() {
    return {
      valIndicadores: null,
      currentPage: 1,
      rowsPerPage: 10,
    };
  },
  methods: {
    ...mapActions(["ReporteAvances"]),
    showPage(page) {

      var table = document.getElementsByClassName("table")[0];
      var rows = table.getElementsByTagName("tr");

      var startIndex = (page - 1) * this.rowsPerPage;
      var endIndex = startIndex + this.rowsPerPage;

      for (var i = 1; i < rows.length; i++) {
        if (i >= startIndex && i < endIndex) {
          rows[i].style.display = "table-row";
        } else {
          rows[i].style.display = "none";
        }
      }
    },
    createPagination() {
      var table = document.getElementsByClassName("table")[0];
      var rows = table.getElementsByTagName("tr");
      var totalPages = Math.ceil((rows.length - 1) / this.rowsPerPage);

      var pagination = document.getElementById("pagination");
      pagination.innerHTML = "";

      for (var i = 1; i <= totalPages; i++) {

        var link = document.createElement("a");

        link.href = "#";
        link.innerHTML = i;
        link.rowsPerPage = this.rowsPerPage;


        if (i === this.currentPage) {
          link.className = "active";
        }

        link.addEventListener("click", function () {
          this.currentPage = parseInt(this.innerHTML);
          this.rowsPerPage = parseInt(this.rowsPerPage);
          //this.showPage(this.currentPage);
          var table = document.getElementsByClassName("table")[0];
          var rows = table.getElementsByTagName("tr");

          var startIndex = (this.currentPage - 1) * this.rowsPerPage;
          var endIndex = startIndex + this.rowsPerPage;

          for (var i = 1; i < rows.length; i++) {
            if (i >= startIndex && i < endIndex) {
              rows[i].style.display = "table-row";
            } else {
              rows[i].style.display = "none";
            }
          }
          //fin.
          var currentLink = document.getElementsByClassName("active")[0];
          currentLink.className = "";
          this.className = "active";
        });

       
        pagination.appendChild(link);
      }

    },
  },
  created() {
    this.ReporteAvances();
    this.$nextTick(function () {
      //alert("created nextTick");
      this.showPage(this.currentPage);
      this.createPagination();
    });
  },
  computed: {
    ...mapGetters(["greporteavances"]),
  },
  watch: {
    greporteavances: function () {
      this.valIndicadores = this.greporteavances;
      this.$nextTick(function () {
        //alert("watch nextTick");
        this.showPage(this.currentPage);
        this.createPagination();
      });
    },
  },
};
</script>

<style>
.card {
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
  transition: 0.3s;
  border-radius: 5px;
  background-color: white;
  padding: 20px;
  width: 80%;
  overflow-x: scroll;
  height: 800px;
  margin: 0 auto;
}

.table {
  border-collapse: collapse;
  margin-bottom: 1rem;
  background-color: white;
  border: 1px solid #dee2e6;
  color: #212529;
}

.table th,
.table td {
  padding: 0.75rem;
  vertical-align: top;
  border-top: 1px solid #dee2e6;

  max-width: 300px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

}

.table td p {
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.table th {
  background-color: #f8f9fa;
  border-color: #dee2e6;
  font-weight: bold;
  text-align: left;
}

.table tbody tr:nth-of-type(odd) {
  background-color: #f2f2f2;
}

.table tbody tr:last-of-type {
  border-bottom: 2px solid #dee2e6;
}

.table tbody tr:hover {
  background-color: #e9ecef;
}


.pagination {
  margin-top: 10px;
  width: 100%;
  
  display: table-cell !important;
}

.pagination a {
  color: #000;
  float: left;
  padding: 8px 8px;
  text-align: center;
  text-decoration: none;
  transition: background-color 0.3s;
  border: 1px solid #ddd;
  margin: 0 4px;
  border-radius: 4px;
  width: 50px;
  margin-bottom: 10px;
}

.pagination a.active {
  background-color: #4caf50;
  color: white;
  border: 1px solid #4caf50;
}

.pagination a:hover:not(.active) {
  background-color: #ddd;
}
</style>
